module.exports = __webpack_public_path__ + "img/corendon.6db375c3.png";